export default __webpack_public_path__ + "static/media/Untitled_Artwork-9.14dadf42.png";